import normalizeSelectedAccounts from './normalizeSelectedAccounts';

const mapRisk = ({
	groupComponentId,
	riskId,
	groupComponentRiskId,
	riskName,
	riskTypeId,
	accounts = [],
	relatedPrimaryRisks = [],
	relatedComponentRisks = [],
	groupRiskStatusId,
	rationale,
	createUser,
	modifyUser,
	rationaleModifyBy,
	rationaleModifyDate,
	concurrencyToken
}) => ({
	groupComponentId,
	riskId,
	groupComponentRiskId,
	riskName,
	riskTypeId,
	accounts: normalizeSelectedAccounts(accounts),
	relatedPrimaryRisks,
	relatedComponentRisks,
	groupRiskStatusId,
	rationale,
	createUser,
	modifyUser,
	rationaleModifyBy,
	rationaleModifyDate,
	concurrencyToken
});

export default (risks) => {
	return risks?.map(mapRisk);
};
